import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=57a97f62&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=57a97f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a97f62",
  null
  
)

export default component.exports